import { Controller } from '@hotwired/stimulus'

/**
 * Makes table rows or other elements clickable for navigation.
 * Uses data-clickable-row-href-value to specify the destination URL.
 *
 * Usage:
 *   <tr data-controller="clickable-row" data-clickable-row-href-value="/path/to/page">
 *     <td>Content</td>
 *   </tr>
 */
export default class extends Controller {
  static values = {
    href: String
  }

  connect() {
    this.element.style.cursor = 'pointer'
  }

  navigate(event) {
    if (event.target.closest('a, button, input, select, textarea')) {
      return
    }

    if (this.hasHrefValue && this.hrefValue) {
      window.location.href = this.hrefValue
    }
  }
}
